// @flow
import { roles } from '../../dataTypes/orderRequests/roles';


export const role2translationMap: Map<string, string> = new Map([
  [roles.Cafeteria, 'order_requests_role_cafeteria'],
  [roles.Dealer, 'order_requests_role_dealer'],
  [roles.School, 'order_requests_role_school'],
  [roles.Admin, 'order_requests_role_admin'],
  [roles.Template, 'order_requests_role_template'],
]);
